export default __webpack_public_path__ + "static/media/Chat-Numbers-System-03.4d38dde8.svg";